import { CircularProgress } from '@material-ui/core';
import GroupedSelect from 'components/form/GroupedSelect';
import React from 'react';
import { useQueryWithStore } from 'react-admin';
import { formatNameWithTrademark } from 'services/helpers/formatNameWithTrademark';
import { getDomesticCountryCode } from 'services/helpers/countryCode';

const packageTypesToGroupedOptions = (data, carriers) =>
  data
    ?.filter((i) => !carriers || !i.provider || carriers.includes(i.provider))
    ?.reduce((acc, curVal) => {
      const newEntry = { value: curVal.code, label: formatNameWithTrademark(curVal.label) };
      const groupLabel = curVal.provider || 'Standard';
      const group = acc.find((i) => i.label === groupLabel);

      if (!group) {
        acc.push({ label: groupLabel, options: [{ ...newEntry }] });
      } else {
        group.options = [...group.options, { ...newEntry }];
      }

      return acc;
    }, [])
    ?.sort((a, b) => {
      // Sort groups: Standard first, then alphabetically
      if (a.label === 'Standard') return -1;
      if (b.label === 'Standard') return 1;
      return a.label.localeCompare(b.label);
    });

const PackageTypeSelect = ({
  label,
  name,
  carriers = undefined,
  dstCountry = undefined,
  srcCountry = undefined,
  excludeHazmat = false,
  excludeAlcohol = false,
  orderId = undefined,
  groupId = undefined,
  ...rest
}) => {
  const countryCode = getDomesticCountryCode();

  const { loaded, error, data } = useQueryWithStore({
    type: 'get',
    resource: 'enabledPackages',
    payload: {
      dstCountry: dstCountry ?? countryCode,
      srcCountry: srcCountry ?? countryCode,
      ...(orderId ? { orderId } : {}),
      ...(groupId ? { groupId } : {}),
    },
  });

  const filteredData = data?.filter(
    (i) =>
      (excludeHazmat ? !i?.code?.includes('HAZMAT') : true) &&
      (excludeAlcohol ? !i?.code?.includes('ALCOHOL') : true)
  );

  if (!loaded) {
    return <CircularProgress />;
  }

  if (error) {
    return <p>error</p>;
  }

  const options = packageTypesToGroupedOptions(filteredData, carriers);

  return <GroupedSelect label={label} name={name} options={options} {...rest} />;
};

export default PackageTypeSelect;
